export default "__VITE_ASSET__B$yx0dNY__"